// Lucide icon: zoom-in (https://lucide.dev/icons/zoom-in)
import { ZoomIn } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconZoomIn = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ZoomIn />
    </IconComponentStyled>
  )
}
